import React from "react";
import { Flex, Box } from "grid-styled";
import Modal from "./Modal";
import Button from "./Button";
import { InputContainer, FranchiseSelect } from "./forms";

class ChangeFranchiseModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      franchiseId: props.franchiseId
    };
  }

  componentWillReceiveProps({ franchiseId: newFranchiseId }) {
    if (newFranchiseId && this.state.franchiseId !== newFranchiseId) {
      this.setState({ franchiseId: newFranchiseId });
    }
  }

  handleFranchiseChange = franchiseId => {
    this.setState({ franchiseId });
  };

  handleSubmit = evt => {
    evt.preventDefault();
    this.props.onSubmit(this.state);
  };

  render() {
    return (
      <Modal
        title="Changing franchise..."
        isOpen={this.props.isOpen}
        close={this.props.onClose}
      >
        <Box p={2}>
          <Box pb={2}>
            <InputContainer
              name="franchiseId"
              labelText="New Franchise"
              value={this.state.franchiseId}
              fieldComponent={FranchiseSelect}
              onChange={this.handleFranchiseChange}
            />
          </Box>
          <Flex justify="flex-end">
            <Button type="button" onClick={this.props.onClose}>
              Cancel
            </Button>
            <Button type="button" variant="primary" onClick={this.handleSubmit}>
              Change franchise
            </Button>
          </Flex>
        </Box>
      </Modal>
    );
  }
}

export default ChangeFranchiseModal;



// WEBPACK FOOTER //
// ./src/components/ChangeFranchiseModal.js